<template>
    <div>
        <div v-if="equalLoanOffers.length > 0" class="offers-group">
            <h2 class="mt-5 offer-heading">{{ equalLoanOffersHeading }}</h2>
            <div v-for="(offer, index) in equalLoanOffers" :key="index" class="offer-block">
                <OfferBlock
                    :offer="offer"
                    :offerIndex="index"
                    :offerCount="standardOffers.length"
                    :expired="expired"
                    :isAgentPage="isAgentPage"
                    :loanAmount="loanAmount"
                >
                    <OfferContent :offer="offer" :loanAmount="loanAmount" />
                </OfferBlock>
            </div>
        </div>

        <div v-if="nonEqualLoanOffers.length > 0" class="offers-group">
            <h2 class="mt-5 offer-heading">{{ nonEqualLoanOffersHeading }}</h2>
            <div v-for="(offer, index) in nonEqualLoanOffers" :key="index" class="offer-block">
                <OfferBlock
                    :offer="offer"
                    :offerIndex="index"
                    :offerCount="standardOffers.length"
                    :expired="expired"
                    :isAgentPage="isAgentPage"
                    :loanAmount="loanAmount"
                >
                    <OfferContent :offer="offer" :loanAmount="loanAmount" />
                </OfferBlock>
            </div>
        </div>

        <div v-if="rangeLoanOffers.length > 0" class="offers-group">
            <h2 class="mt-5 offer-heading">{{ rangeLoanOffersHeading }}</h2>
            <div v-for="(offer, index) in rangeLoanOffers" :key="index" class="offer-block">
                <OfferBlock
                    :offer="offer"
                    :offerIndex="index"
                    :offerCount="standardOffers.length"
                    :expired="expired"
                    :isAgentPage="isAgentPage"
                    :loanAmount="loanAmount"
                >
                    <OfferContent :offer="offer" :loanAmount="loanAmount" />
                </OfferBlock>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['offers', 'expired', 'isAgentPage', 'applicationData', 'loanAmount', 'standardOffers'],
    computed: {
        equalLoanOffers: function () {
            return this.standardOffers.filter(
                offer => offer.loan_amount.min === this.applicationData.loan_amount && !offer.loan_amount.max,
            )
        },
        nonEqualLoanOffers: function () {
            return this.standardOffers.filter(
                offer => offer.loan_amount.min !== this.applicationData.loan_amount && !offer.loan_amount.max,
            )
        },
        rangeLoanOffers: function () {
            return this.standardOffers.filter(offer => offer.loan_amount.min && offer.loan_amount.max)
        },
        equalLoanOffersHeading: function () {
            return this.equalLoanOffers.length === 1
                ? this.$t('results.headings.equalLoanOffer')
                : this.$t('results.headings.equalLoanOffers')
        },
        nonEqualLoanOffersHeading: function () {
            return this.nonEqualLoanOffers.length === 1
                ? this.$t('results.headings.nonEqualLoanOffer')
                : this.$t('results.headings.nonEqualLoanOffers')
        },
        rangeLoanOffersHeading: function () {
            return this.$t('results.headings.rangeLoanOffers')
        },
    },
}
</script>
